export default {"src":"/_next/static/media/creditCard.8940926f.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};